/**
 * NOTA:
 * Per far funzionare questo script, c'� bisogno di inserire nel bottone il 
 * data attribute con valore pari all'ID della modale da aprire.
 * 
 * Es. per fare in modo che il bottone apra il dialog con ID "foo", bisogner�
 * creare un elemento cos�:
 * <button class=".class" data-dialog="foo"></button>
 */

export function getDefaultOptions() {
    return {
        /**
         * Il selettore del bottone che apre il dialog.
         */
        openDialogButtonsSelector: '.open-dialog',
        /**
         * Il selettore del bottone che chiude il dialog.
         */
        closeDialogButtonSelector: '.close-dialog',
        /**
         * Il data attribute a cui viene passato l'ID del dialogo da aprire.
         */
        idDialogAttribute: `data-dialog`,
    };
}

export function initialize(_options = getDefaultOptions()) {
    const options = _options;

    console.log("Initializing modal management.");

    //Gestione apertura dialog
    var apriDialogButtons = document.querySelectorAll(options.openDialogButtonsSelector);
    apriDialogButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            var dialogId = this.getAttribute(options.idDialogAttribute);
            var dialog = document.getElementById(dialogId);

            if (dialog) {
                dialog.showModal();
            }
        });
    });
 
    // Gestione chiusura dialog
    var chiudiDialogButtons = document.querySelectorAll(options.closeDialogButtonSelector);
    chiudiDialogButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            var dialog = this.closest('dialog');

            if (dialog) {
                dialog.close();
            }
        });
    });

    console.log("Modal controls initialized.");
}